export type SocialDetails = {
    socialUserName: string;
    socialUrl: string;
    network: SocialNetworkName;
};

export const PREFIX_HTTPS = 'https://' as const;
export const PREFIX_WWW = 'www.' as const;

export const socialNetworksConfig = {
    Facebook: {
        exampleUrl: 'https://www.facebook.com/1stDibs/',
        baseUrls: ['facebook.com/', 'facebook.com/groups/'],
        // the number of path segments allowed when validating the array
        // FB, IG: ['1stDibs'].length === 1
        // LinkedIn: ['in', '1stDibs'].length === 2
        validSegmentsLength: [1, 2],
    },
    Instagram: {
        exampleUrl: 'https://www.instagram.com/1stDibs/',
        baseUrls: ['instagram.com/'],
        validSegmentsLength: [1],
    },
    Website: {
        exampleUrl: 'https://yoursite.com',
    },
} as const;

export type SocialNetworkName = keyof typeof socialNetworksConfig;
